/**
 * Authors: mariushirjanu
 * Created: 04/08/2021
 */
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { Transition } from '@uirouter/angular';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { InvoiceModule } from '../invoice/invoice.module';
import { CompanyProfilesComponent } from './company-profiles.component';
import { STATE_COMPANYPROFILES, STATE_COMPANYPROFILES_INVOICEDETAIL, STATE_COMPANYPROFILES_INVOICEOVERVIEW, STATE_COMPANYPROFILES_INVOICETEMPLATES } from '@app/shared/app-states';
import { CompanyProfilesInvoiceComponent } from './company-profiles-invoice.component';
import { CompanyProfileDataService } from './company-profiles-data.service';
import { InvoiceTemplatesComponent } from '@app/shared/invoice/templates/invoice-templates.component';
import { InvoiceTemplateDetailComponent } from '@app/shared/invoice/templates/invoice-template-detail.component';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

export const states:GaStateDeclaration[] = [
  {
    name: STATE_COMPANYPROFILES,
    url: '/companyprofiles/:companyCountryId',
    abstract: true,
    views: {
      content: {
        component: CompanyProfilesComponent
      }
    },
    data: {
      modules: [TranslationCategory.INVOICE]
    },
    resolve: [
      TRANSLATION_READY_RESOLVER,
      {
        token: 'companyCountryId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().companyCountryId)
      }
    ]
  },
  {
    name: STATE_COMPANYPROFILES_INVOICETEMPLATES,
    url: '/invoice',
    abstract: true,
    component: CompanyProfilesInvoiceComponent,
    resolve: [
      {
        token: 'detailState',
        resolveFn: () => STATE_COMPANYPROFILES_INVOICEDETAIL
      },
      {
        token: 'writeSupport',
        resolveFn: () => true
      }
    ]
  },
  {
    name: STATE_COMPANYPROFILES_INVOICEOVERVIEW,
    url: '',
    component: InvoiceTemplatesComponent,
    data: {
      viewTitle: 'Invoice Templates',
      viewCode: 'companyprofiles.invoice-templates',
      noMaxWidth: true
    }
  },
  {
    name: STATE_COMPANYPROFILES_INVOICEDETAIL,
    url: '/:invoiceTemplateId',
    component: InvoiceTemplateDetailComponent,
    resolve: [
      {
        token: 'invoiceTemplateId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => Number(trans.params().invoiceTemplateId)
      },
      {
        token: 'overviewState',
        resolveFn: () => STATE_COMPANYPROFILES_INVOICEOVERVIEW
      }
    ],
    data: {
      viewTitle: 'Invoice Template Detail',
      viewCode: 'companyprofiles.invoice-templates'
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule,
    InvoiceModule
  ],
  declarations: [
    CompanyProfilesComponent,
    CompanyProfilesInvoiceComponent
  ],
  providers: [
    CompanyProfileDataService
  ]
})
export class CompanyProfilesModule {
}